var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"challenge-counter"},[_vm._v("\n    Nästa utmaning\n    "),_c('span',[_vm._v(_vm._s(this.lessThenTen(_vm.days))+" : "+_vm._s(this.lessThenTen(_vm.hours))+" : "+_vm._s(this.lessThenTen(_vm.minutes))+" :\n        "+_vm._s(this.lessThenTen(_vm.seconds)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }